import React, { useRef, useState } from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import { useUpdateEffect } from 'react-use';
import styled from 'styled-components/macro';
import { defaultDelay } from 'utils/configs';
import Spinner from './Spinner/Spinner';

const StyledPreloaderWrapper = styled.div<{ area: string }>`
  position: absolute;
  top: ${({ area }) => (area === 'leftBottom' ? 'auto' : 0)};
  right: ${({ area }) => (area === 'leftBottom' ? 'auto' : 0)};
  left: ${({ area }) => (area === 'leftBottom' ? '15px' : 0)};
  bottom: ${({ area }) => (area === 'leftBottom' ? '15px' : 0)};
  z-index: ${({ theme }) => theme.zIndexPalette.highest};
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme, area }) => (area === 'leftBottom' ? 'none' : theme.colorPalette.white)}99;
`;

interface Props {
  area?: string;
}

/* avoid white flickering for request
just a bit longer than delay */
const durationAtLeast = 1000;

const Preloader = ({ area = 'app' }: Props) => {
  const timerId = useRef(0);
  const [visible, setVisible] = useState(false);
  const { promiseInProgress } = usePromiseTracker({ area: area, delay: defaultDelay });

  useUpdateEffect(() => {
    if (!promiseInProgress && durationAtLeast > 499) {
      setVisible(true);
      timerId.current = setTimeout(() => setVisible(false), durationAtLeast);
    }
    return () => clearTimeout(timerId.current);
  }, [promiseInProgress]);

  return promiseInProgress || visible ? (
    <StyledPreloaderWrapper area={area}>
      <Spinner size={60} />
    </StyledPreloaderWrapper>
  ) : null;
};

export default Preloader;
